module.exports = __webpack_public_path__ + "img/50.dbb251a4.jpg";